import type { FC, ReactNode } from 'react'

interface ScriptHeadingProps {
    lead: string
    tail: string
}

const StarGlyph: FC = (): ReactNode => (
    <svg viewBox='0 0 30 30' aria-hidden='true' className='size-4 fill-brand'>
        <path d='M 5.738 28.5 L 8.175 17.963 L 0 10.875 L 10.8 9.938 L 15 0 L 19.2 9.938 L 30 10.875 L 21.825 17.963 L 24.262 28.5 L 15 22.912 Z' />
    </svg>
)

/** Centred five-star strip above a two-line serif heading with an italic second line. */
export const ScriptHeading: FC<ScriptHeadingProps> = ({ lead, tail }): ReactNode => {
    return (
        <div className='shell flex flex-col items-center py-16 md:py-20' data-reveal='up'>
            <div className='flex gap-1.5'>
                {[0, 1, 2, 3, 4].map((star) => (
                    <StarGlyph key={star} />
                ))}
            </div>

            <p className='t-h5 mt-5 text-center'>
                <span className='block'>
                    {lead}
                </span>

                <em className='block'>
                    {tail}
                </em>
            </p>
        </div>
    )
}
